(function($) {

	$.fn.formcheckboxtree = function() {

		return this.each(function() {
			var $this = $(this);

            $this.find('input:checkbox').change(function(){

                var $checkbox = $(this);
                var id = $checkbox.val();
                var $parentCheckbox = $this.find('.parent-of-' + id).find('input:checkbox').addBack().filter('input:checkbox');
                var $childCheckboxes = $this.find('.child-of-' + id).find('input:checkbox').addBack().filter('input:checkbox');
                var $siblingCheckboxes = $this.find('.child-of-' + $parentCheckbox.val()).find('input:checkbox').addBack().filter('input:checkbox').not('input[value='+id+']');
                if($checkbox.is(':checked')) {
                    // Check all children
                    $childCheckboxes.filter(':not(:checked)').each(function(){
                        $(this).prop('checked', true).trigger('change');
                    });
                    // Uncheck parent if all siblings are checked
                    if(!$parentCheckbox.prop('checked') && $siblingCheckboxes.filter(':not(:checked)').size()==0) {
                        $parentCheckbox.prop('checked', true).trigger('change');
                    }
                }
                else {
                    // Uncheck all children
                    $childCheckboxes.filter(':checked').each(function(){
                        $(this).prop('checked', false).trigger('change');
                    });
                    // Uncheck parent
                    if($parentCheckbox.prop('checked')) {
                        $parentCheckbox.prop('checked', false);
                    }
                }
            });
        });
	};

})(jQuery);